import { render } from "./WaitingPage.vue?vue&type=template&id=92c9ed66&scoped=true"
import script from "./WaitingPage.vue?vue&type=script&lang=js"
export * from "./WaitingPage.vue?vue&type=script&lang=js"

import "./WaitingPage.vue?vue&type=style&index=0&id=92c9ed66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92c9ed66"]])

export default __exports__